/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepLogBase } from './AutoTestStepLogBase';
import { IOTestStepLog } from './IOTestStepLog';
const IOTestLogParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['steps', /* #__PURE__ */ codecArray(IOTestStepLog)],
]), AutoTestStepLogBase);
export class IOTestLog extends AutoTestStepLogBase {
    static decode(input) {
        return IOTestLogParser.decode(input).map(res => new IOTestLog(res));
    }
    static unsafeDecode(input) {
        return IOTestLog.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestLogParser.encode(data);
    }
    static schema() {
        return IOTestLogParser.schema();
    }
}
